export class CreateUserInput {
  id?: string;
  country!: string;
  firstName!: string;
  middleName?: string;
  lastName!: string;
  phoneNumber!: string;
  email!: string;
  password!: string;
  companyId!: string;
  role?: string;
}
